import React, { useState } from "react";
import Internal_Audit_Form from "./internal_Audit_Form/Internal_Audit_Form";
import Internal_Audit_table from "./internal_Audit_table/Internal_Audit_table";
import Edit_Internal_Audit from "./edit_Internal_Audit/Edit_Internal_Audit";

function Internal_Audit() {
  const [isEdit, setIsEdit] = useState(false);

  return (
    <section className="Imperiality">
      {isEdit ? (
        <Edit_Internal_Audit onCancel={() => setIsEdit(false)} />
      ) : (
        <>
          <div className="imperiality_Form_div">
            <Internal_Audit_Form />
          </div>

          <div className="imperiality_table_div">
            <Internal_Audit_table onEdit={() => setIsEdit(true)} />
          </div>
        </>
      )}
    </section>
  );
}

export default Internal_Audit;
